import * as React from 'react';
import { Form, Tabs, Tab } from 'react-bootstrap'
import { useImmer } from 'use-immer';
import * as _ from 'lodash';
import {  AxiosInstance } from '../../../utils/RequestMethods';
import ButtonLoading from '../../../components/ButtonLoading/ButtonLoading';
import config from '../../../constants/config';
import { CompanyT } from '../../../types/Company';
import { stringLitArray } from '../../../utils/utilsT';
import NumberFormatValidate from '../../../components/NumberFormatValidate';

export interface IMailServerTestProps {
    company: CompanyT

}


const initFields = {
    to: "",
    subject: "",
    message: "",
    isHtml: true,
}
const MailServerTest: React.FC<IMailServerTestProps> = ({ company }) => {
    const [dirty, setDirty] = useImmer(initFields)
    // const [fields, setFields] = React.useState(initFields)
    const [validated, setValidated] = React.useState(false)
    const form = React.useRef(null)


    /**
     *
     */
    const submitSaveCompany = async (): Promise<string> => {
        let params = { ...dirty }

        return await sendEmailTest(params)
    }
    /**
    *
    * @param params
    */
    const sendEmailTest = async (params): Promise<string> => {
        if (!params) {
            params = {}
        }
        try {
            let res = await AxiosInstance.post(`${config.url.companies}/${company.id}/send_email`, params)
            if (res && res.data) {

                return 'Send email test.'
            }
        } catch (error) {

            throw new Error(error)

        }
    }
    /**
    *
    * @param key
    * @param value
    */
    const onChangeFields = (key, value) => {
        if (value == undefined) {
            value = ""
        }
        setDirty(draft => {
            draft[key] = value
        })
    }

    return (
        <div>
            <Form
                // onSubmit={handleSubmit}
                noValidate
                ref={form}
                validated={validated}>

                <Form.Group>
                    <Form.Label>To</Form.Label>
                    <Form.Control
                        className='input-material'
                        value={`${dirty['to']}`}
                        onChange={(event) => {
                            onChangeFields("to", event.target.value)
                        }}
                    // required={true}
                    />

                </Form.Group>

                <Form.Group>
                    <Form.Label>Subject</Form.Label>
                    <Form.Control
                        className='input-material'
                        value={`${dirty['subject']}`}
                        onChange={(event) => {
                            onChangeFields("subject", event.target.value)
                        }}
                    // required={true}
                    />

                </Form.Group>

                <Form.Group>
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        className='input-material'
                        value={`${dirty.message}`}
                        onChange={(event) => {
                            onChangeFields("message", event.target.value)
                        }}
                    // required={true}
                    />

                </Form.Group>
                <Form.Group>
                    <Form.Label>Is Html</Form.Label>
                    <Form.Check
                        id="custom-switch"
                        checked={dirty['isHtml']}
                        type="switch"
                        onChange={(event) => {
                            onChangeFields("isHtml", !dirty.isHtml)

                        }}

                        label={dirty.isHtml ? "ON" : "OFF"}
                    />

                </Form.Group>
                <ButtonLoading
                    id="submit-button-s"
                    // disabled={true}
                    className="btn-primary"
                    onClickFetching={async (e): Promise<string> => {
                        //e.stopPropagation()
                        return await submitSaveCompany()
                    }}
                >
                    Send </ButtonLoading>
            </Form>
        </div>
    );
}
export default MailServerTest
export { MailServerTest };
